// 新聞頁面 - 你可能會喜歡區塊
'use client';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { popState } from '@/slices/popSlice';
import useHorizontalDrag from '@/hook/useHorizontalDrag';

import NewsRelatedComponent from './NewsRelatedComponent'; // 新聞元件
import newsClient from '@/common/apiClient/newsClient';

const NewsRelatedWrapper = ({ newsId, locale }) => {
    const { t } = useTranslation();
    const { showMenu } = useSelector(popState);
    const { wrapRef, mouseDownHandler, isDragging } = useHorizontalDrag(); // 處理拖拉用

    // 推薦新聞
    const [relatedNews, setRelatedNews] = useState([]);

    // 取得推薦新聞
    const fetchRelatedNews = async () => {
        try {
            const { news } = await newsClient.findRelatedNews(newsId, locale);
            if (news) setRelatedNews(news);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        fetchRelatedNews();
    }, []);

    if (relatedNews?.length)
        return (
            <section
                className={`relative bg-white bg-opacity-[.02] pt-[30px] pb-[35px] space-y-[30px] ${
                    showMenu ? 'w-[calc(100vw-200px)]' : 'w-[calc(100vw-60px)]'
                }
                ulg:w-full ulg:!mt-[10px]`}
            >
                {/* 標題 */}
                <h4 className="text-h3 text-white text-center">{t('RELATED')}</h4>

                <div
                    className="max-w-full noScrollX"
                    ref={wrapRef}
                    onMouseDown={(e) => mouseDownHandler(e)}
                >
                    <div className="w-max px-[30px] flex items-center gap-x-[15px] usm:px-[15px] [&>*]:w-[290px]">
                        {/* 卡片元件 */}
                        {relatedNews?.map((news, i) => (
                            <NewsRelatedComponent
                                key={`news-recommend-${i}`}
                                news={news}
                                t={t}
                                isDragging={isDragging}
                            />
                        ))}
                    </div>
                </div>

                {/* 評論跳轉線 */}
                <hr className="opacity-0 z-[-1] absolute top-[-50px]" id="comment-target" />
            </section>
        );

    return null;
};

export default NewsRelatedWrapper;
